// eslint-disable-next-line import/no-anonymous-default-export
export default {
  formId: "new-company-form",
  formField: {
    // datas
    name: {
      name: "name",
      label: "Nome",
      type: "text",
      errorMsg: "O nome é obrigatório",
      invalidMsg: "Nome inválido",
    },
    email: {
      name: "email",
      label: "Email",
      type: "email",
      errorMsg: "O email é obrigatório",
      invalidMsg: "Email inválido",
    },
    CNPJ: {
      name: "CNPJ",
      label: "CNPJ",
      type: "text",
      mask: "CNPJ",
      errorMsg: "O CNPJ é obrigatório",
      invalidMsg: "CNPJ inválido",
    },
    employer_code: {
      name: "employer_code",
      label: "Código empregador",
      type: "text",
      errorMsg: "O Código empregador é obrigatório",
      invalidMsg: "Código empregador inválido",
    },
  },
}